import * as Definitions from "./Definitions";
import { Observable } from "rxjs";
import { Effects } from "../";
export const description = "Deletes a coupon from a specified cart.";
export const method = "DELETE";
export const operationId = "quoteCouponManagementV1RemoveDelete";
export const path = "/V1/carts/mine/coupons";
export type Response = Response200 | Response400 | Response401 | ResponseDefault;
export type Response200 = boolean;
export type Response400 = Definitions.ErrorResponse;
export type Response401 = Definitions.ErrorResponse;
export type ResponseDefault = Definitions.ErrorResponse;
type MinimalEffects = Pick<Effects, "apiUrl" | "restHeaders" | "deleteJSON">;
export function execute(effects: MinimalEffects): Observable<Response200> {
    return effects.deleteJSON(effects.apiUrl(operationId)(path, undefined), null, effects.restHeaders({})) as any;
}
